import { useInitializeDocumentFilters, useInitializeDocumentTypes } from './hooks'

interface ContactDocumentsInitializationProps {
  contactId: string
}

export const ContactDocumentsInitialization: React.FC<ContactDocumentsInitializationProps> = ({ contactId }) => {
  useInitializeDocumentTypes()
  useInitializeDocumentFilters(contactId)

  return null
}
